import global from 'window-or-global';
import DK from '../lang-values/DK';

const getTexts = () => {
    return global.T || DK;
};

export default getTexts;
